import "./WelcomeComponent.css";
import { useEffect, useRef, useState } from "react";

export default function WelcomeComponent() {
  const elements = useRef([]);
  const [visibleItems, setVisibleItems] = useState([]);

  const sections = [
    "Nato per sperimentare",
    "Concretizzando soluzioni",
    "Evitando spese inutili",
  ]; 

  useEffect(() => {
    const observedElements = elements.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.getAttribute("data-index"));
          if (entry.isIntersecting) {
            setVisibleItems((prev) => {
              if (!prev.includes(index)) return [...prev, index];
              return prev;
            });
          } else {
            setVisibleItems((prev) => prev.filter((i) => i !== index));
          }
        });
      },
      { threshold: 0.75 }
    );

    observedElements.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      observedElements.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  return (
    <>
      {sections.map((text, index) => (
        <div
          key={index}
          ref={(el) => (elements.current[index] = el)}
          data-index={index}
          className={`text-component ${visibleItems.includes(index) ? "visible" : ""}`}
        >
          <div className="text-container text glass-effect">
            <h2>{text}</h2>
          </div>
        </div>
      ))}
    </>
  );
}
